import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';
import { HOLLOW_CENTER_TOOLTIP } from '../../../Preview/PreviewDisplayConstants';

// Global Hollow Center. Non-custom layers inherit this; a custom layer keeps its own override.
// The parent (VisualizerShapeEditor) only renders this for the circle shape and the styles that fill
// the center (bar, solid), where it applies.
const VisualizerHollowCenterListItem = (props) => {
    const { visualizerHollowCenter, updateVisualizerSettings } = props;
    const onHollowCenterChange = (event) => updateVisualizerSettings({ hollowCenter: event.target.checked });

    return (
        <SwitchListItem
            text='Hollow Center'
            checked={visualizerHollowCenter ?? false}
            onChange={onHollowCenterChange}
            toolTip={HOLLOW_CENTER_TOOLTIP}
        />
    );
};

const mapStateToProps = (state) => {
    const { hollowCenter: visualizerHollowCenter } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerHollowCenter };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerHollowCenterListItem);
